"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const kendo_react_dropdowns_1 = require("@progress/kendo-react-dropdowns");
const pagination_number_component_1 = __importDefault(require("./pagination-number.component"));
require("./pagination.style.css");
const CustomPagination = (props) => {
    const onPageChange = (num) => {
        if (props.onPageChange) {
            props.onPageChange(num);
        }
    };
    const onTakeChange = (num) => {
        if (props.onTakeChange) {
            props.onTakeChange(num);
        }
    };
    const showing = props.skip + props.take > props.total ? props.total : props.skip + props.take;
    // const page = (props.skip + props.take) / props.take
    // const showing = (page - 1) * props.total
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: `${props.className} pagination-container` }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'pagination-left' }, { children: [(0, jsx_runtime_1.jsx)("small", Object.assign({ className: 'pagination-info' }, { children: `Showing ${props.skip + 1}-${showing == 0 ?
                            props.total > props.take ?
                                props.take
                                : props.total
                            : showing} of ${props.total}` })), (0, jsx_runtime_1.jsx)("small", Object.assign({ className: 'pagination-option' }, { children: 'Listing Per Page' })), (0, jsx_runtime_1.jsx)(kendo_react_dropdowns_1.DropDownList, { style: { height: 20 }, value: props.take, data: [10, 20, 30, 40], onChange: e => onTakeChange(e.target.value) })] })), (0, jsx_runtime_1.jsx)(pagination_number_component_1.default, { total: props.total, take: props.take, onPageChange: onPageChange, skip: props.skip })] })));
};
exports.default = CustomPagination;
